import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Handle, Position } from "@xyflow/react";
import { CatHeading } from "blocks-nextjs/blocks-react/components/Heading/Heading";
import { CatIconFlash } from "blocks-nextjs/blocks-react/components/Icons/Flash/Flash";
import { useIsIndianaChargerStationFlag } from "../../hooks/useIsIndianaChargerStationFlag";
import { CatDieselGeneratorIcon } from "./CatDieselGeneratorIcon";
import { CatGeneratorIcon } from "./CatGeneratorIcon";
export const UtilityPowerNode = ({ data }) => {
    const isIndianaStation = useIsIndianaChargerStationFlag(data?.assetName, data?.assetSourceType);
    let assetType = "DEFAULT";
    if (isIndianaStation) {
        assetType = "INDIANA_STATION";
    }
    else if (data?.assetSourceType?.toUpperCase() === "DIESEL_GENERATOR") {
        assetType = "DIESEL_GENERATOR";
    }
    const getLabel = () => {
        if (isIndianaStation)
            return "Generator";
        return "Grid Power";
    };
    const assetIcons = {
        DEFAULT: (_jsx(CatIconFlash, { className: "flex items-center justify-center", "data-test": "flash-icon", "flash-icon": true, size: "xl" })),
        DIESEL_GENERATOR: _jsx(CatDieselGeneratorIcon, { className: "flex items-center justify-center", size: "xl" }),
        INDIANA_STATION: _jsx(CatGeneratorIcon, { className: "flex items-center justify-center", size: "xl" })
    };
    return (_jsx(_Fragment, { children: _jsx("div", { "data-test": "utility-power-node-container", children: _jsxs("div", { className: "relative border-solid border-2 rounded-full border-gray-800 w-20 h-20 text-center content-center text-black box-border", "data-test": "main-div", children: [_jsx(CatHeading, { className: "whitespace-nowrap absolute top-[-55px] text-black left-1/2 -translate-x-1/2", variant: "title", children: getLabel() }), _jsx("div", { children: assetIcons[assetType] ?? assetIcons.DEFAULT }), _jsx(Handle, { "data-test": "handle", isConnectable: false, position: Position.Right, type: "source" })] }) }) }));
};
